module.exports = __webpack_public_path__ + "static/media/7.1.2. INDICE DE INFORMACION CLASIFICADA Y RESERVADA NOTARIA (1).9708c422.pdf";